import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Environment } from 'dashboard/models/environment';
import { RootState } from 'dashboard/redux/store';
import usePrevious from 'lib/hooks/usePrevious';

/**
 * useRedirectOnEnvironmentChange
 *
 * useEffect hook that runs when currentEnvironment changes. When it does, boots
 * you back to the specified parent route. Should be used in show views, as the
 * entity for the current page generally should not be viewable once the user
 * presses the sandbox toggle.
 */
export default function useEffectOnEnvironmentChange(effectCallback: () => void): void {
  const currentEnvironment = useSelector<RootState, Environment>(
    (state) => state.currentEnvironment.currentEnvironment,
  );

  const prevEnvironment = usePrevious(currentEnvironment);

  useEffect(() => {
    if (
      currentEnvironment != null &&
      prevEnvironment != null &&
      currentEnvironment.id !== prevEnvironment.id
    ) {
      effectCallback();
    }
  }, [currentEnvironment]);
}
